import React, { useEffect, useState } from "react";

// 14. Juni 2026 · 12:00 CEST
const TARGET = new Date("2026-06-14T10:00:00Z").getTime();

const pad = (n) => String(Math.max(0, n));

const calc = () => {
    const diff = Math.max(0, TARGET - Date.now());
    return {
        days: Math.floor(diff / 86400000),
        hours: Math.floor((diff / 3600000) % 24),
        minutes: Math.floor((diff / 60000) % 60),
        seconds: Math.floor((diff / 1000) % 60),
    };
};

const Unit = ({ value, label, testid }) => (
    <div
        className="flex flex-col items-center"
        data-testid={`countdown-cell-${testid}`}
    >
        <span
            className="font-medium leading-[0.9] tracking-[-0.04em] text-[64px] sm:text-[88px] lg:text-[112px]"
            style={{
                color: "var(--plenum-text)",
                fontFamily: "var(--font-mono)",
                fontVariantNumeric: "tabular-nums",
                fontFeatureSettings: '"tnum" on',
            }}
            data-testid={`countdown-value-${testid}`}
        >
            {pad(value)}
        </span>
        <span
            className="mt-5 sm:mt-6 text-[10px] sm:text-[11px] uppercase tracking-[0.32em]"
            style={{
                color: "var(--plenum-accent-2)",
                fontFamily: "var(--font-mono)",
            }}
        >
            {label}
        </span>
    </div>
);

export const Countdown = () => {
    const [t, setT] = useState(calc());

    useEffect(() => {
        const id = setInterval(() => setT(calc()), 1000);
        return () => clearInterval(id);
    }, []);

    return (
        <div
            className="w-full"
            data-testid="countdown-container"
            aria-label={`${t.days} Tage ${t.hours} Stunden ${t.minutes} Minuten ${t.seconds} Sekunden bis zum Abstimmungssonntag`}
        >
            <div
                aria-hidden="true"
                style={{
                    height: "1px",
                    width: "100%",
                    backgroundColor: "var(--plenum-line-2)",
                }}
            />

            <div className="flex flex-wrap justify-center gap-x-10 sm:gap-x-16 lg:gap-x-24 gap-y-10 py-12 sm:py-14">
                <Unit value={t.days} label="Tage" testid="days" width={3} />
                <Unit value={t.hours} label="Stunden" testid="hours" />
                <Unit value={t.minutes} label="Minuten" testid="minutes" />
                <Unit value={t.seconds} label="Sekunden" testid="seconds" />
            </div>

            <div
                aria-hidden="true"
                style={{
                    height: "1px",
                    width: "100%",
                    backgroundColor: "var(--plenum-line-2)",
                }}
            />
        </div>
    );
};

export default Countdown;
